import React from "react"; // eslint-disable-line no-unused-vars
import styled from "styled-components";
import moment from "moment-timezone";

const Box = styled.div`
  background-color: #fff;
  color: #444;
  padding: 5px;
  display: flex;
  //  border-top: 1px solid #eee;
  border-right: 1px solid #fff;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: ${props => (props.time ? "0.9em" : "inherit")};
  border-top: ${props => (props.time ? "1px solid #eee" : "inherit")};
  &:nth-child(2) {
    border-top: ${props => (props.time ? "none" : "inherit")};
  }
`;
const Past = Box.extend`
  border-top: none;
  border-right: none;
  /*  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAM0lEQVQoU2NkwAP+////nxGXPFgSBLApgEmC5DAUIEtiKECXRFGATRKuAJckWAE+SZACAIKGIAUwJOAdAAAAAElFTkSuQmCC)
    repeat;*/
  /*url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAIklEQVQYV2NkQAI9PT3/GWF8EKekpIQRLADjgNiMyByQAADHBQ6o45FCxgAAAABJRU5ErkJggg==)
    repeat;*/
  //  background-color: #ccc;
  background-color: transparent;
`;
export const CustomClosedContainer = Box.extend`
  border-top: 1px solid #ed6262;
  border-right: 1px solid #ed6262;
  background-color: #f67979;
  cursor: pointer;
  &:hover {
    background-color: #ed6262;
    color:#eee;

    &::before {
      content: "${props => props.time}";
    }
  }
`;

class CustomClosed extends React.Component {
  state = { isPast: false };
  componentDidMount() {
    let interval = (this.props.date.diff(moment(), "minutes") + 1) * 60000;
    if (interval >= 2147483647) {
      interval = 2147483647;
    }
    this.interval = setTimeout(() => this.setState({ isPast: true }), interval);
  }
  componentWillUnmount() {
    clearTimeout(this.interval);
  }

  render() {
    if (this.state.isPast) {
      return <Past />;
    }
    return (
      <CustomClosedContainer
        time={this.props.time}
        onClick={this.props.onClick}
      />
    );
  }
}

export default CustomClosed;



// WEBPACK FOOTER //
// ./src/components/utilities/calendar/CustomClosed.js